import { render, staticRenderFns } from "./ChapterPreview.vue?vue&type=template&id=60cfa784&scoped=true&"
import script from "./ChapterPreview.vue?vue&type=script&lang=js&"
export * from "./ChapterPreview.vue?vue&type=script&lang=js&"
import style0 from "./ChapterPreview.vue?vue&type=style&index=0&id=60cfa784&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cfa784",
  null
  
)

component.options.__file = "ChapterPreview.vue"
export default component.exports